import { ACTIONS } from "../../enums/actions";

export const getAccountLoginsByCompany = (payload: any, onSuccess: Function | null = null, onFail: Function | null = null) => ({
    type: ACTIONS.GET_ACCOUNT_LOGINS_BY_COMPANY,
    payload,
    onSuccess: onSuccess || null,
    onFail: onFail || null
});